import { FeaturePost } from '../FeaturePosts';
import { milestonesAndStreaks } from './2026-10-20-milestones-and-streaks';
import { homeScreenWidgets } from './2026-10-06-home-screen-widgets';
import { doctorSummaryPdf } from './2026-09-20-doctor-summary-pdf';
import { insightsAndTrends } from './2026-08-22-insights-and-trends';
import { moodTracker } from './2026-06-02-mood-tracker';

// Add new feature pages here, one file per feature named YYYY-MM-DD-slug.tsx.
// They're shown newest first by date, so order here doesn't matter.
export const posts: FeaturePost[] = [
  milestonesAndStreaks,
  homeScreenWidgets,
  doctorSummaryPdf,
  insightsAndTrends,
  moodTracker,
];
